import { render, staticRenderFns } from "./bottom-footer.vue?vue&type=template&id=02f5e1ab&scoped=true&"
import script from "./bottom-footer.vue?vue&type=script&lang=js&"
export * from "./bottom-footer.vue?vue&type=script&lang=js&"
import style0 from "./bottom-footer.vue?vue&type=style&index=0&id=02f5e1ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f5e1ab",
  null
  
)

export default component.exports